import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@nano/common';
import { FormModule } from '@nano/common/form';
import { ImageModule } from '@nano/common/image';
import { L10nTranslationModule } from 'angular-l10n';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';

import { UserMenuItemsComponent } from './user-menu-items.component';

@NgModule({
  imports: [CommonModule, FormModule, FormsModule, L10nTranslationModule, ImageModule, NzMenuModule, NzDropDownModule, NzDrawerModule, NzCollapseModule],
  declarations: [UserMenuItemsComponent],
  exports: [UserMenuItemsComponent]
})
export class UserMenuItemsModule {}
